import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { LoadingInterceptor } from './interceptors/loading.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

function initializeAppFactory() {
  const translate = inject(TranslateService);
  translate.setDefaultLang('en');
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('userLang') : null;
  const browser = translate.getBrowserLang() || 'en';
  const lang = saved || browser;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
  return firstValueFrom(translate.use(lang));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([LoadingInterceptor])),
    provideRouter(routes),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideAppInitializer(initializeAppFactory),
    provideCharts(withDefaultRegisterables()),
  ],
};
